import { Component } from '@angular/core';

@Component({
  selector: 'empathy-ranking',
  templateUrl: './ranking-description.component.html',
  styleUrls: ['./ranking-description.component.scss']
})
export class RankingDescriptionComponent {}
